export { API, BACKEND_URL } from '@/config/api';
// Default Gradio URL - users get fresh URLs from iMagine dashboard "Try" button
export const DEFAULT_GRADIO_URL = "";

/**
 * Parse predictions for display from various response formats
 */
export const parsePredictions = (predictions) => {
  if (!predictions) return [];
  
  // Handle iMagine Gradio response format
  // Format: {pred_lab: [['label1', 'label2', ...]], pred_prob: [[0.5, 0.3, ...]]}
  if (predictions.pred_lab && predictions.pred_prob) {
    const labels = predictions.pred_lab[0] || predictions.pred_lab;
    const probs = predictions.pred_prob[0] || predictions.pred_prob;
    
    return labels.map((label, i) => ({
      label: label,
      probability: probs[i] || 0
    })).slice(0, 5);
  }
  
  // Handle string that needs JSON parsing (from Gradio)
  if (typeof predictions === 'string') {
    try {
      const parsed = JSON.parse(predictions.replace(/'/g, '"'));
      return parsePredictions(parsed);
    } catch {
      return [];
    }
  }
  
  // Handle nested predictions object
  if (predictions.predictions) {
    return parsePredictions(predictions.predictions);
  }
  
  // Handle raw response that contains the prediction string
  if (predictions.raw) {
    return parsePredictions(predictions.raw);
  }
  
  // Handle different response formats
  if (Array.isArray(predictions)) {
    return predictions.slice(0, 5).map(p => ({
      label: p.label || p.class || p,
      probability: p.probability || p.confidence || 0
    }));
  }
  
  if (predictions.labels && predictions.probabilities) {
    return predictions.labels.map((label, i) => ({
      label,
      probability: predictions.probabilities[i]
    })).slice(0, 5);
  }
  
  // If it's an object with class names as keys
  if (typeof predictions === 'object' && !predictions.status && !predictions.message) {
    return Object.entries(predictions)
      .filter(([key]) => !['status', 'message', 'raw', 'filenames', 'aphia_ids'].includes(key))
      .map(([label, prob]) => ({ label, probability: typeof prob === 'number' ? prob : 0 }))
      .sort((a, b) => b.probability - a.probability)
      .slice(0, 5);
  }
  
  return [];
};
